module.exports = __webpack_public_path__ + "img/评估中心.0ae8053a.png";